(function () {
    "use strict";

    angular
        .module("UndergroundWebApp")
        .controller("StatisticsController", StatisticsController);

    StatisticsController.$inject = [
        "$q",
        "$scope",
        "$rootScope",
        "$stateParams",
        "containerService",
        "chartOptionsService",
        "$translate",
        "filterStateService",
        "$timeout",
        "kendoGridUtility",
    ];

    function StatisticsController(
        $q,
        $scope,
        $rootScope,
        $stateParams,
        containerService,
        chartOptionsService,
        $translate,
        filterStateService,
        $timeout,
        kendoGridUtility,
    ) {
        $scope.locationId = null;
        $scope.dateRange = {};

        $scope.charts = [];
        $scope.getChartData = getChartData;

        $scope.isDateFilterWarningVisible = false;
        $scope.dateFilterWarningMessage = '';


        let isOpenAccessIntervaInvalid = false;

        initController();

        function initController() {
            loadContainer();
        }

        $scope.statisticsAccessEventsGridOptions = {
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: readStatisticAccessEvents,
                },
                schema: {
                    model: {
                        fields: {
                            time: { type: "date" },
                            outcome: {},
                            uid: {},
                        },
                    },
                },
                pageSize: 70,
                sort: filterStateService.getSortFromQueryString(),
                filter: filterStateService.getFilterFromQueryString(),
            }),
            pageable: {
                refresh: true,
                pageSizes: [20, 50, 100, 200],
                buttonCount: 5,
            },
            columns: [
                {
                    field: "time",
                    title: $translate.instant(
                        "STATISTICS_CONTROLLER_GRID_TIME"
                    ),
                    template: function(dataItem) {
                        var dt = kendoGridUtility.getLocalDateCell(dataItem.time);
                        return kendo.toString(dt, $translate.instant("G_DEFAULT_DATE_FORMAT"));
                    },
                    width: "auto",
                    lockable: false,
                    type: "date",
                },
                {
                    field: "outcome",
                    title: $translate.instant(
                        "STATISTICS_CONTROLLER_GRID_OUTCOME"
                    ),
                    width: "auto",
                    lockable: false,
                    template: function(dataItem) {
                            var translationKey = dataItem.outcome;
                            if (translationKey) {
                                return $translate.instant(translationKey);
                            }
                            return "";
                        }
                },
                {
                    field: "nfcUid",
                    title: $translate.instant("STATISTICS_CONTROLLER_GRID_UID"),
                    width: "auto",
                    lockable: false,
                },
            ],
            scrollable: {
                virtual: true,
            },
            sortable: true,
            filterable: true,
            noRecords: true,
            selectable: false,
            resizable: true,
            sort: filterStateService.storeGridSortInQueryString,
            filter: filterStateService.storeGridFilterInQueryString,
            groupable: false,
            excel: {
                fileName: $scope.excelFileName,
                filterable: true,
                allPages: true,
            },
        };

        function loadContainer() {
            containerService
                .getContainerByRelatedDevice($stateParams.deviceId)
                .then(function (container) {
                    if (container) {
                        $scope.locationId = container.locationId;
                        $scope.containerId = container.devices.length
                            ? container.devices[0].containerId
                            : null;
                        $scope.title = getPageTitle(container);
                    }
                    $scope.getChartData();
                });
        }

        function getPageTitle(container) {
            var titleParts = [];
            if (container.location && container.location.name) {
                titleParts.push(container.location.name);
            }
            if (container.containerNumber) {
                titleParts.push(container.containerNumber);
            }
            if (container.fraction && container.fraction.name) {
                titleParts.push(container.fraction.name);
            }

            return titleParts.join(" - ");
        }

        function getChartData() {
            if ($scope.containerId && $stateParams.deviceId) {
                var fromDate = moment($scope.dateRange.from);
                var toDate = moment($scope.dateRange.to);

                if (!fromDate.isValid() || !toDate.isValid()) {
                    $scope.isDateFilterWarningVisible = true;
                    $scope.dateFilterWarningMessage = $translate.instant("STATISTICS_CONTROLLER_INVALID_DATE_RANGE");
                    return;
                }

                if (fromDate.isAfter(toDate)) {
                    $scope.isDateFilterWarningVisible = true;
                    $scope.dateFilterWarningMessage = $translate.instant("STATISTICS_CONTROLLER_WRONG_INTERVAL");
                    return;
                }

                var diffInDays = toDate.diff(fromDate, 'days');
                if (diffInDays > 31) {
                    $scope.isDateFilterWarningVisible = true;
                    isOpenAccessIntervaInvalid = true;
                    $scope.dateFilterWarningMessage = $translate.instant("STATISTICS_CONTROLLER_TOO_BIG_INTERVAL");
                } else {
                    isOpenAccessIntervaInvalid = false;
                    $scope.isDateFilterWarningVisible = false;
                    $scope.dateFilterWarningMessage = '';
                }
                $rootScope.$broadcast("showBusyIndicator", {
                    id: "containerIndicator",
                    destination: "#statistics-view",
                    message: $translate.instant("G_BUSY_INDICATOR"),
                    overlay: true,
                    positionClass: {
                        top: "50%",
                        left: "0px",
                        right: "0px",
                    },
                });
                const containerStatPromise =
                    containerService.getContainerStatistics(
                        $stateParams.containerId,
                        moment(fromDate).format("YYYY-MM-DD"),
                        moment(toDate).format("YYYY-MM-DD")
                    );

                const promises = [containerStatPromise];

                if (!isOpenAccessIntervaInvalid) {
                    const openAccessEventsPromise =
                        containerService.getContainerOpenAccessEvents(
                            $scope.containerId,
                            fromDate.format("YYYY-MM-DD"),
                            toDate.format("YYYY-MM-DD")
                        );
                    promises.push(openAccessEventsPromise);
                }

                $q.all(promises)
                    .then((result) => {
                        $scope.statistics = result[0];
                        $scope.openAccessEvents = result[1];
                        var charts = [];

                        if (
                            hasDataToDrawChart(
                                $scope.statistics,
                                chartOptionsService.chartTypes.fill
                            )
                        ) {
                            charts.push(
                                chartOptionsService.createChart(
                                    $scope.statistics,
                                    chartOptionsService.chartTypes.fill,
                                    $translate.instant(
                                        "STATISTICS_CONTROLLER_CHART_FILL"
                                    ),
                                    "blue",
                                    "area",
                                    {
                                        valueAxis: {
                                            min: 0,
                                            max: 100,
                                        },
                                    }
                                )
                            );
                        }

                        if (
                            $rootScope.isVisible("CORE", {
                                Area: "SignalStrengthReport",
                                AccessType: "W",
                            }) &&
                            hasDataToDrawChart(
                                $scope.statistics,
                                chartOptionsService.chartTypes.rssi
                            )
                        ) {
                            charts.push(
                                chartOptionsService.createChart(
                                    $scope.statistics,
                                    chartOptionsService.chartTypes.rssi,
                                    $translate.instant(
                                        "STATISTICS_CONTROLLER_CHART_SIGNAL_STRENGTH"
                                    ),
                                    "red",
                                    "area"
                                )
                            );
                        }

                        $scope.statistics = _.filter(
                            $scope.statistics,
                            ({ volt }) => volt > 0
                        );

                        if (
                            $scope.openAccessEvents &&
                            $scope.openAccessEvents.length
                        ) {
                            charts.push(
                                chartOptionsService.createChart(
                                    processChartData($scope.openAccessEvents),
                                    chartOptionsService.chartTypes
                                        .openAccessEvent,
                                    $translate.instant(
                                        "STATISTICS_CONTROLLER_CHART_USAGE_COUNT"
                                    ),
                                    "purple",
                                    "column",
                                    {
                                        seriesClick: onFillChartClick,
                                    }
                                )
                            );
                        }

                        $scope.charts = charts;
                        $timeout(() => {
                            if (
                                $scope.statisticsAccessEventsGrid &&
                                $scope.statisticsAccessEventsGrid.dataSource
                            ) {
                                $scope.statisticsAccessEventsGrid.dataSource.read();
                            } else {
                                console.warn(
                                    "Grid or datasource not available yet."
                                );
                            }
                        });
                    })
                    .finally(() =>
                        $rootScope.$broadcast(
                            "hideBusyIndicator",
                            "containerIndicator"
                        )
                    );
            }
        }

        function hasDataToDrawChart(statistics, type) {
            if (!statistics || !statistics.length) {
                return false;
            }

            const atLeastOneDataEntryHasValue = statistics.some(
                (x) => x[type] != 0
            );
            return atLeastOneDataEntryHasValue;
        }

        function processChartData(data) {
            let groupedData = {};

            data.forEach((item) => {
                let date = item.eventData.access.event.time.split("T")[0]; // Extract YYYY-MM-DD
                groupedData[date] = (groupedData[date] || 0) + 1;
            });

            return Object.keys(groupedData).map((date) => ({
                timestamp: date,
                openAccessEvent: groupedData[date],
            }));
        }

        function readStatisticAccessEvents(e) {
            if ($scope.openAccessEvents) {
                const gridElements = $scope.openAccessEvents
                .filter((event) => event.eventData?.access?.event?.origin?.nfc?.uid)
                .map((event) => { 
                    event.eventData.access.event.origin.nfc.nfcUid =
                        event.eventData.access.event.origin.nfc.uid || "";

                    return {
                        time: event.eventData.access.event.time,
                        outcome: event.eventData.access.event.outcome,
                        nfcUid: event.eventData.access.event.origin.nfc.nfcUid,
                    };
                });
                e.success(gridElements);
            } else {
                console.warn("No openAccessEvents available!");
                e.success([]);
            }
        }

        function onFillChartClick(e) {
            const clickedDate = moment(e.dataItem.timestamp).format("YYYY-MM-DD");

            if ($scope.statisticsAccessEventsGrid) {
                let filter = {};
                if ($scope.clickedDate === clickedDate) {
                    $scope.clickedDate = null;
                } else {
                    $scope.clickedDate = clickedDate;
                    filter = {
                        field: "time",
                        operator: function (itemDate) {
                            return (
                                moment(itemDate).format("YYYY-MM-DD") ===
                                clickedDate
                            );
                        },
                    };
                }
                $scope.statisticsAccessEventsGrid.dataSource.filter(filter);
            }
        }
    }
})();
